module.exports = __webpack_public_path__ + "static/media/avatar_pig.6d04e7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_pig.png
// module id = 394
// module chunks = 0